export const variantConfig = {
  light: 'text-on-surface',
  primary: 'text-primary',
  info: 'text-info',
  success: 'text-success',
  warning: 'text-warning',
  error: 'text-error'
}

export const variantConfigBg = {
  light: 'bg-background',
  primary: 'bg-primary-container border-primary',
  info: 'bg-info-container border-info',
  success: 'bg-success-container border-success',
  warning: 'bg-warning-container border-warning',
  error: 'bg-error-container border-error'
}
